var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18145 8.36174L10.8269 10.869M10.9615 3.9405L5.03846 6.61178M5.30769 7.4615C5.30769 8.65201 4.34435 9.61535 3.15385 9.61535C1.96334 9.61535 1 8.65201 1 7.4615C1 6.271 1.96334 5.30765 3.15385 5.30765C4.34435 5.30765 5.30769 6.271 5.30769 7.4615ZM15 3.15385C15 4.34435 14.0367 5.30769 12.8462 5.30769C11.6556 5.30769 10.6923 4.34435 10.6923 3.15385C10.6923 1.96334 11.6556 1 12.8462 1C14.0367 1 15 1.96334 15 3.15385ZM15 11.7693C15 12.9598 14.0367 13.9231 12.8462 13.9231C11.6556 13.9231 10.6923 12.9598 10.6923 11.7693C10.6923 10.5788 11.6556 9.61542 12.8462 9.61542C14.0367 9.61542 15 10.5788 15 11.7693Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.4e1d7c640490c6315e18a0f06ea3cd6a.svg";
export { ForwardRef as ReactComponent };